export const ORDER_BY = {
  ASC: 'asc',
  DESC: 'desc',
}
export const HEADER_TEXT = 'Setup by School'
export const NEXT_BUTTON_TEXT = 'Next'
export const NO_CLASSES_TEXT = 'No Classes Yet'
export const PREVIOUS_BUTTON_TEXT = 'Previous'
export const SETUP_PROGRESS_TEXT = 'Setup Progress'
export const SITES_HEADER_TEXT = 'School'
export const SORT_KEYS = {
  [SETUP_PROGRESS_TEXT]: 'planProgressNumber',
  [SITES_HEADER_TEXT]: 'name',
}
